import React, { Component, Fragment } from 'react';
// import Datas from '../../../data/course/item.json';
import Datas from '../../../data/course/slider.json';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import Pagination from './../../../components/Pagination';


class CourseItemGrid extends Component {
    render() {
        return (
            <Fragment>


                {Datas.dataList.map((item, i) => (
                    <Col lg="4" md="12" key={i}>
                        <div className="course-item" style={{ height: "480px" }}>
                            <Link to={`/course-details/${item.id}`}>
                                <div className="course-image" style={{ backgroundImage: `url(/assets/images/${item.imgUrl})` }}>
                                    <div className="author-img d-flex">
                                        {/* <div className="img">
                                                <img src={`/assets/images/${item.authorImg}`} alt="" />
                                            </div> */}
                                        <div className="title">
                                            <p>{item.authorName}</p>
                                            <span>{item.authorCourses}</span>
                                        </div>
                                    </div>
                                    <div className="course-price">
                                        <p>{item.price}</p>
                                    </div>
                                </div>
                            </Link>
                            <div className="course-content">
                                <h6 className="heading">
                                    <Link to={`/course-details/${item.id}`}>{item.courseTitle}</Link>
                                </h6>
                                <p className="desc">{item.courseDesc}</p>
                                <div className="course-footer">
                                    <Link to="/registration" className="apply-btn w-50 d-flex align-items-center justify-content-center p-3 rounded" style={{ backgroundColor: '#048504', color: '#fff'}}>
                                        Apply Now
                                    </Link>
                                </div>

                                {/* <div className="course-face d-flex justify-content-between">
                                        <div className="duration">
                                            <p><i className="las la-clock"></i>120</p>
                                        </div>
                                        <div className="rating">
                                            <ul className="list-unstyled list-inline">
                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                <li className="list-inline-item"><i className="las la-star-half-alt"></i>
                                                </li>
                                                <li className="list-inline-item">(4.5)</li>
                                            </ul>
                                        </div>
                                        <div className="student">
                                            <p><i className="las la-chair"></i>60</p>
                                        </div>
                                    </div> */}
                            </div>
                        </div>
                    </Col>
                ))}


                <Col md="12" className="text-center">
                    <Pagination />
                </Col>
            </Fragment>
        )
    }
}

export default CourseItemGrid
